import React, {useImperativeHandle, useRef} from "react";
import {formatFileSize, getFileExtension, getFileName} from "../../../utils/utils";
import {toast} from "react-toastify";
import {FormattedMessage, useIntl} from "react-intl";
import drive from "../index";
import {useDispatch, useSelector} from "react-redux";
import functions from "../../../utils/functionsFirebase";

const UploadUtils = React.forwardRef((props, ref) => {


    const dispatch = useDispatch();
    const intl = useIntl();

    const componenteARef = useRef(null);
    const fileQueue = useSelector(drive.selectors.getUploadQueue);
    const currentFolderId = useSelector(drive.selectors.getCurrentFolderId);
    const draggingItem = useSelector(drive.selectors.isDraggingItem);

    const addFilesToQueue = async (files, folderId) => {
        const newFiles = [];
        const currentFiles = [...fileQueue, ...newFiles];
        const wrongFiles = [];

        for (let file of files) {
            if (file) {
                const fileObject = {
                    file,
                    name: getFileName(file.name),
                    extension: getFileExtension(file.name),
                    folderId
                };
                // Si el archivo está en la cola (coincide nombre y tamaño), no se vuelve a añadir
                if (currentFiles.some(x => x.file.name === file.name && x.file.size === file.size)) {
                    toast.error(intl.formatMessage({id: "drive.contextual.queue.already-uploading"}));
                    continue;
                }
                const repeatFiles = currentFiles.filter(x => getFileName(x.file.name) === fileObject.name).length;
                if (repeatFiles > 0) {
                    const fileCount = ` (${repeatFiles})`;
                    fileObject.name = fileObject.name + fileCount
                }
                newFiles.push(fileObject);
                currentFiles.push(fileObject);
            }
        }
        if (wrongFiles.length > 0) {
            toast.error(
                <FormattedMessage id={"drive.contextual.queue.exceeds-size"} values={{fileSize: formatFileSize(0)}}/>
            );
        }

        dispatch(drive.actions.addFilesToUploadQueue(newFiles));
    }

    const handleAddFilesButton = () => {

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '*';
        input.multiple = true;

        input.onchange = (event) => {
            addFilesToQueue(event.target.files, currentFolderId);
        };

        input.click();
    };

    async function traverseDirectory(directoryEntry, parentFolderId) {

        const createFolder = functions.httpsCallable('createFolder');
        const res = await createFolder({
            folder: {
                name: directoryEntry.name,
                folderId: parentFolderId
            }
        });
        const dirEntries = await directoryEntry.values();
        const addedFiles = [];

        if (parentFolderId === currentFolderId) {
            dispatch(drive.actions.folderCreated(res.data.folder));
        }

        for await (const entry of dirEntries) {
            if (entry.kind === 'directory') {
                // Recursively traverse subdirectories
                await traverseDirectory(entry, res.data.folder.id);
            } else {
                // Process file entry
                const fileHandle = await entry.getFile();
                addedFiles.push(fileHandle);
            }
        }

        if (addedFiles.length > 0) {
            addFilesToQueue(addedFiles, res.data.folder.id);
        }
    }

    async function dropHandler(ev, folderId) {
        if (draggingItem) {
            return;
        }
        const listaFicheros = document.getElementById('lista-ficheros')
        listaFicheros.classList.add('drive__dropZoneInactive');

        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        const addFiles = [];
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            const auxItems = [...ev.dataTransfer.items];
            const promises = auxItems.map(async (item) => {
                if (item.kind === 'file') {
                    if (item.getAsFileSystemHandle) {
                        const entry = await item.getAsFileSystemHandle();
                        if (entry && entry.kind === 'directory') {
                            // Dropped item is a folder
                            toast.error(intl.formatMessage({id: "fileUploadMenu.drop-items.folder-forbidden"}));
                            return null;
                        } else {
                            // Dropped item is a file
                            return entry.getFile();
                        }
                    } else {
                        const file = item.getAsFile();
                        if (file.type) {
                            return file;
                        } else {
                            return null;
                        }
                    }
                }
            });
            const resolvedPromises = await Promise.all(promises);
            const addedFiles = resolvedPromises.filter((file) => file !== null);
            addFiles.push(...addedFiles);

        } else {
            // Use DataTransfer interface to access the file(s)
            const auxFiles = [...ev.dataTransfer.files];
            for (const file of auxFiles) {
                addFiles.push(file);
            }
        }
        if (addFiles.length > 0) {
            await addFilesToQueue(addFiles, folderId);
        }
    }

    // Define las funciones y métodos que deseas exponer desde el componente
    useImperativeHandle(ref, () => ({
        handleAddFilesButton: () => {
           handleAddFilesButton();
        },
        dropHandler: (event, folderId) => {
            return dropHandler(event, folderId);
        }
    }));

    return (
        <div style={{display: "none"}} ref={componenteARef}>

        </div>
    )

});

export default UploadUtils;
